import React, { FC } from 'react';
import { useTemplateContext } from '@components/Contexts/TemplateContext';
import { Box, Heading } from '@wix/design-system';
import ReviewSummary from '@components/Template/Hero/HeroInfo/ReviewSummary';
import CreatorInfo from '@components/Template/Hero/HeroInfo/CreatorInfo';
import PurchaseCTAs from '@components/Template/PurchaseCTAs';
import s from './MobileHeroInfo.module.scss';

interface Props {
  setPurchaseError: (isError: boolean) => void;
}

const MobileHeroInfo: FC<Props> = ({ setPurchaseError }) => {
  const { template } = useTemplateContext();

  return (
    <Box direction="vertical" padding="24px">
      <Heading size="large" ellipsis maxLines={2} as="h1">
        {template.title}
      </Heading>
      <ReviewSummary includeReviewsLink={false} useMiniPurchaseCount />
      <CreatorInfo className={s.creatorInfoPadding} textSize={'small'} />
      <PurchaseCTAs
        isMobileView={true}
        className={s.purchaseCTAsWrapper}
        buttonSize="medium"
        setPurchaseError={setPurchaseError}
      />
    </Box>
  );
};

export default MobileHeroInfo;
